import React from "react";
import { withRouter } from "react-router-dom";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";

import HexagonContainer from "containers/Next/Hexagon";

import DoubleOutcomeChart from "components/Next/Charts/DoubleOutcomeChart";

import { CHART_TYPES } from "containers/Report/ReportReducer";
import { colors } from "containers/Next/NextReducer";

import styles from "./style.module.css";

export default class Subgroup extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { blueprintId, splitOptions, splitColumn, isUpdatingProject, updateSplitColumn, createProject } = this.props;

    return (
      <div className={styles.subgroup}>
        <div className={styles.selectSubheader}>
          {
            "Get a more focused analysis by splitting the the analysis into groups like region, promotion type, or business unit."
          }
        </div>
        <div className={styles.subgroupHeader}>{"I would like to evaluate by:"}</div>
        <div className={styles.splitField}>
          <Select
            options={splitOptions}
            isClearable
            onChange={(val) => updateSplitColumn(val ? val.value : val)}
            value={splitColumn ? { label: splitColumn, value: splitColumn } : undefined}
          />
        </div>
        {blueprintId !== "new" && (
          <div className={styles.retrainButton}>
            {isUpdatingProject ? (
              <div>
                {"Creating Models..."}
                <LoadingIndicator
                  style={{
                    margin: "0px",
                    marginLeft: "15px",
                    marginTop: "10px"
                  }}
                />
              </div>
            ) : (
              <Button
                disabled={splitColumn === undefined || splitColumn === null}
                type="primary"
                onClick={() => createProject()}
              >
                {"Create New Models"}
              </Button>
            )}
          </div>
        )}
      </div>
    );
  }
}
